<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">ประวัติการใช้งานเครดิต</h1>
                    <p class="text-white pb-3 px-3">สรุปการใช้งานเครดิตของคุณ</p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-12">
                                    <b-form-group id="input-group-1"
                                        label="ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1"
                                        class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-4">
                                                <date-range-picker class="w-100" :opens="'center'"
                                                    @start-selection="logEvent('startSelection', $event)"
                                                    @finish-selection="logEvent('finishSelection', $event)"
                                                    :min-date="minDate" :max-date="maxDate" :singleDatePicker="false"
                                                    :appendToBody="true" :ranges="false" :closeOnEsc="false"
                                                    :autoApply="true" :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                            </div>
                                            <div class="col-lg-3">
                                                <select v-if="this.main_use_walletV2" v-model="filterStatus"
                                                    class="form-control">
                                                    <option :value="status.key" v-for="status in table_filter_wallet_v2"
                                                        :key="status.key">
                                                        {{ status.title }}
                                                    </option>
                                                </select>
                                                <select v-else v-model="filterStatus" class="form-control">
                                                    <option :value="status.key" v-for="status in dataStatus"
                                                        :key="status.key">
                                                        {{ status.title }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-lg-3">
                                                <select v-if="this.main_use_walletV2" v-model="filterStatus2"
                                                    class="form-control">
                                                    <option :value="status.key"
                                                        v-for="status in table_filter_wallet_2_v2" :key="status.key">
                                                        {{ status.title }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res"
                                                    @click="funcHistoryTopUpWallet()">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                                <div class="col-lg-12">
                                    <div class="row align-self-center">
                                        <div class="col-lg-4">
                                            <b-form-group label="ตัวกรอง" label-for="input-1" class="mb-0">
                                                <b-form-input v-model="filter" type="text"
                                                    placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                                            </b-form-group>
                                        </div>
                                        <div class="col-lg-3">
                                            <b-form-group label="Export File" class="mb-0 pb-2">
                                                <div class="btn-group btn-sm-res btn-export" role="group"
                                                    aria-label="Basic example">
                                                    <ExportExcel :columns="fields('excel')"
                                                        :getData="funcGetDataBranceExportExcel"
                                                        name="สรุปการใช้งาน wellet ">
                                                    </ExportExcel>
                                                    <b-button variant="info btn-sm-res"
                                                        @click="$htmlToPaper('tablePrint')">print</b-button>
                                                </div>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table v-if="this.main_use_walletV2" class="scroll-bar-pop"
                                empty-text="ไม่มีรายละเอียดการใช้งานเครดิต"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา" :items="dataUsegeWallet"
                                :fields="table_fields_wallet_v2" :filter="filter" :busy="busy" show-empty responsive
                                :sort-compare="sortCompare">
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">
                                    {{ data.index + 1 }}
                                </template>
                                <template slot="created_at" slot-scope="row">
                                    {{ row.item.created_at | dateFormat(main_use_walletV2) }}
                                    <!-- {{ row.item.created_at }} -->

                                </template>
                                <template slot="id" slot-scope="row">
                                    {{ row.item.id }}
                                </template>
                                <template slot="tracking_code" slot-scope="row">
                                    <span v-if="!row.item.subject.includes('deposit')">
                                        {{ row.item.ref_no2 }}
                                    </span>
                                </template>
                                <template slot="tx_type" slot-scope="row">
                                    {{ transformTxTypeText(row.item.subject, row.item.ref_code, row.item.remark) }}
                                </template>
                                <template slot="value" slot-scope="row">
                                    <span v-if="[
                                        wallet_subject_deposit
                                    ].includes(row.item.subject)" style="color: #28A745;">
                                        + {{ row.item.value | numFormat('0,0.00') }}
                                        <label v-b-tooltip title="ส่วนลด" v-if="row.item.coupon && row.item.coupon.total_value"> / {{ row.item.coupon ? - (row.item.coupon.total_value) : 0 | numFormat('0,0.00') }}</label>
                                    </span>
                                    <span v-else-if="[
                                        wallet_subject_withdraw,
                                        wallet_subject_pendwithdrawconfirmed
                                    ].includes(row.item.subject)" style="color: #FF5050;">
                                        - {{ row.item.value | numFormat('0,0.00') }}
                                        <label v-b-tooltip title="ส่วนลด" v-if="row.item.coupon && row.item.coupon.total_value"> / {{ row.item.coupon ? - (row.item.coupon.total_value) : 0 | numFormat('0,0.00') }}</label>
                                    </span>
                                    <span v-else-if="[
                                        wallet_subject_pendwithdraw
                                    ].includes(row.item.subject)" style="color: #FFA500;">
                                        - {{ row.item.value | numFormat('0,0.00') }}
                                        <label v-b-tooltip title="ส่วนลด" v-if="row.item.coupon && row.item.coupon.total_value"> / {{ row.item.coupon ? - (row.item.coupon.total_value) : 0 | numFormat('0,0.00') }}</label>
                                    </span>
                                    <span v-else-if="[
                                        wallet_subject_pendwithdrawcancelled
                                    ].includes(row.item.subject)" style="color: #28A745;">
                                        <span v-if="row.item.ref_code === 'REFUND'">
                                            + <span style="color: #28A745;" v-b-tooltip :title="row.item.updated_at | dateFormat(main_use_walletV2)">{{ row.item.value | numFormat('0,0.00') }}</span>
                                        </span>
                                        <span v-else>
                                            - <span style="color: gray;" v-b-tooltip :title="'รายการหักเงินถูกยกเลิก'">{{ row.item.value | numFormat('0,0.00') }}</span>
                                        </span>
                                        <!-- + {{ row.item.value | numFormat('0,0.00') }} -->
                                        <label v-b-tooltip title="ส่วนลด" v-if="row.item.coupon && row.item.coupon.total_value"> / {{ row.item.coupon ? - (row.item.coupon.total_value) : 0 | numFormat('0,0.00') }}</label>
                                    </span>
                                </template>
                                <!-- <template slot="coupon" slot-scope="row">
                                    <span style="color: #FF5050;">
                                        {{ row.item.coupon ? - (row.item.coupon.total_value) : 0 | numFormat('0,0.00') }}
                                    </span>
                                </template> -->
                                <template slot="status" slot-scope="row">
                                    <b-badge v-b-tooltip :title="row.item.updated_at | dateFormat(main_use_walletV2)" v-if="[
                                        wallet_subject_deposit,
                                        wallet_subject_withdraw,
                                        wallet_subject_pendwithdrawconfirmed,
                                        wallet_subject_pendwithdrawcancelled
                                    ].includes(row.item.subject)" variant="success" style="font-size: 13px;">
                                        สำเร็จ
                                    </b-badge>
                                    <b-badge v-else-if="[
                                        wallet_subject_pendwithdraw
                                    ].includes(row.item.subject)"
                                        style="font-size: 13px; background-color: rgba(255, 165, 0, 0.2); color: #FFA500; ">
                                        รอดำเนินการ
                                    </b-badge>
                                </template>
                                <!-- <template slot="updated_at" slot-scope="row">
                                    <span v-if="[
                                        wallet_subject_deposit,
                                        wallet_subject_withdraw,
                                        wallet_subject_pendwithdrawcancelled
                                    ].includes(row.item.subject)">
                                        {{ row.item.updated_at | dateFormat(main_use_walletV2) }}
                                    </span>
                                    <span v-else>
                                        -
                                    </span>
                                </template> -->
                                <template slot="available_balance" slot-scope="row">
                                    <div v-if="wallet_subject_deposit === row.item.subject">
                                        <!-- deposit -->
                                        <span style="color: #28A745;" v-b-tooltip :title="row.item.updated_at | dateFormat(main_use_walletV2)">{{ row.item.available_balance | numFormat('0,0.00') }}</span>
                                    </div>
                                    <div v-else-if="wallet_subject_withdraw === row.item.subject">
                                        <!-- withdraw -->
                                         <span class="text-warning" v-b-tooltip :title="row.item.updated_at | dateFormat(main_use_walletV2)">{{ row.item.available_balance | numFormat('0,0.00') }}</span>
                                    </div>
                                    <div v-else-if="wallet_subject_pendwithdrawconfirmed === row.item.subject">
                                        <!-- withdraw -->
                                         <span class="text-warning" v-b-tooltip :title="row.item.updated_at | dateFormat(main_use_walletV2)">{{ row.item.available_balance | numFormat('0,0.00') }}</span>
                                    </div>
                                    <div v-else-if="wallet_subject_pendwithdrawcancelled === row.item.subject">
                                        <!-- refund -->
                                        <span v-if="row.item.ref_code === 'REFUND'">
                                            <span style="color: #28A745;" v-b-tooltip :title="row.item.updated_at | dateFormat(main_use_walletV2)">{{ row.item.available_balance | numFormat('0,0.00') }}</span>
                                        </span>
                                        <span v-else>
                                            <!-- - -->
                                            <span style="color: gray;" v-b-tooltip :title="'รายการหักเงินถูกยกเลิก'">{{ row.item.available_balance | numFormat('0,0.00') }}</span>
                                        </span>
                                        <!-- <span style="color: #28A745;" v-b-tooltip :title="row.item.updated_at | dateFormat(main_use_walletV2)">{{ row.item.available_balance | numFormat('0,0.00') }}</span> -->
                                    </div>
                                    <div v-else-if="wallet_subject_pendwithdraw === row.item.subject">
                                        <!-- pending -->
                                        <!-- - -->
                                        <span style="color: #FFA500;" v-b-tooltip :title="'รายการหักเงินรอการชำระจริง'">{{ row.item.available_balance | numFormat('0,0.00') }}</span>
                                    </div>
                                </template>

                                <template slot="remark" slot-scope="row">
                                    {{ parseTextFieldRemark(row.item.remark) }}
                                </template>
                            </b-table>
                            <b-table v-else show-empty responsive empty-text="ไม่มีรายละเอียดการใช้งานเครดิต"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา" :tbody-tr-class="rowClass"
                                :items="dataUsegeWallet" :fields="fields()" :filter="filter" :busy="busy"
                                class="scroll-bar-pop" sort-desc
                                :sort-compare="sortCompare">
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">{{ data.index + 1 }}</template>
                                <template slot="created_at" slot-scope="row">{{ row.item.created_at |
                                    dateFormat(main_use_walletV2)
                                    }}</template>
                                <template slot="subject" slot-scope="row">
                                    <span>
                                        {{ statusPaymentSubject(row.item.subject).text }}
                                    </span>
                                </template>
                                <template slot="credit" slot-scope="data">
                                    <span :class="rowClassTransaction(data.item).fontColor">
                                        {{ rowClassTransaction(data.item).text }}
                                    </span>
                                </template>
                                <template slot="status" slot-scope="row">
                                    <b-badge :variant="statusPayment(row.item.status, row.item.subject).color"
                                        class="d-block">
                                        <i :class="statusPayment(row.item.status, row.item.subject).icon"></i>
                                        {{ statusPayment(row.item.status, row.item.subject).status }}
                                    </b-badge>
                                </template>
                                <template slot="ref_no2" slot-scope="row">
                                    <span>{{ checkStatusRefNo2(row.item.ref_no2) }}</span>
                                </template>
                                <template slot="available_credit" slot-scope="row">
                                    <span>{{ row.item.available_credit | numFormat('0,0.00') }}</span>
                                </template>
                                <template slot="accumulated_credit" slot-scope="row">
                                    <span>{{ row.item.accumulated_credit | numFormat('0,0.00') }}</span>
                                </template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination :total-rows="pagination.totalItem" :current-page="pagination.currentPage"
                                    :per-page="pagination.perPage" :value="pagination.currentPage" @input="changePage"
                                    align="right">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import numFormat from "vue-filter-number-format";
import 'moment-timezone/builds/moment-timezone-with-data';
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import {
    statusPaymentSubject,
    statusPayment,
    rowClass,
    rowClassTransaction,
    checkStatusRefNo2,
    convertDataWallet
} from "@/axios/walletPayment.js"
import { dateLimitRanges } from "@/plugins/datePicker.js"

import Mixins from "./report_makeup";

function removePendParams(str) {
    return str
        .split(',')
        .filter(param => !param.startsWith('pend') || param.includes('cancelled'))
        .join(',');
}
function keepOnlyPendParams(str) {
    return str
        .split(',')
        .filter(param => param.startsWith('pend') && !param.includes('cancelled'))
        .join(',');
}

export default {
    mixins: [Mixins],

    name: "historyusagewallet",
    components: {
        ExportExcel
    },
    data() {
        return {
            busy: false,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filters: {
                excelDate: "",
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            filter: null,
            filterStatus: null,
            filterStatus2: null,
            dataStatus: [
                { key: null, title: 'ดูประเภทรายการทั้งหมด' },
                { key: 'deposit', title: 'เติมเครดิต' },
                // { key: 'REFUND' , title: 'คืนเครดิตสาขา' },
                { key: 'withdraw', title: 'ค่าขนส่ง' }
            ],
            dataUsegeWallet: [],
            pagination: {
                totalPage: 1,
                totalItem: 0,
                currentPage: 1,
                perPage: 30,
            },
            statusPaymentSubject: statusPaymentSubject,
            statusPayment: statusPayment,
            rowClass: rowClass,
            rowClassTransaction: rowClassTransaction,
            checkStatusRefNo2: checkStatusRefNo2,

            funcHistoryTopUpWallet: null,
            funcGetDataBranceExportExcel: null,

            table_fields_wallet_v2: [
                {
                    key: "index",
                    field: "index",
                    label: "#",
                    sortable: true
                },
                {
                    key: "created_at",
                    field: "created_at",
                    label: "วันเวลาที่ทำรายการ",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "id",
                    field: "id",
                    label: "เลขที่รายการ",
                    sortable: false,
                    class: "text-center"
                },
                {
                    key: "tracking_code",
                    field: "tracking_code",
                    label: "เลขแทรคกิ้ง",
                    sortable: false,
                    class: "text-center"
                },
                {
                    key: "tx_type",
                    field: "tx_type",
                    label: "ประเภทรายการ",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "value",
                    field: "value",
                    label: "ธุรกรรม/ส่วนลด",
                    sortable: false,
                    class: "text-center"
                },
                // {
                //     key: "coupon",
                //     field: "coupon",
                //     label: "คูปองส่วนลด (บาท)",
                //     sortable: false,
                //     class: "text-center"
                // },
                {
                    key: "status",
                    field: "status",
                    label: "สถานะ",
                    sortable: true,
                    class: "text-center"
                },
                // {
                //     key: "updated_at",
                //     field: "updated_at",
                //     label: "วันเวลาที่รายการสำเร็จ",
                //     sortable: true,
                //     class: "text-center"
                // },
                {
                    key: "available_balance",
                    field: "available_balance",
                    // key: "balance",
                    // field: "balance",
                    label: "ยอดเงินคงเหลือ",
                    sortable: false,
                    class: "text-center"
                },
                {
                    key: "remark",
                    field: "remark",
                    label: "หมายเหตุ",
                    sortable: false
                }
            ],
            table_filter_wallet_v2: [
                // { key: null, title: 'ดูประเภทรายการทั้งหมด' },
                // { key: 'deposit&pend-deposit&pend-deposit-cancelled', title: 'เติมเงิน' },
                // { key: 'withdraw&pend-withdraw&pend-withdraw-cancelled', title: 'ตัดเงิน' }
                { key: null, title: 'ดูประเภทรายการทั้งหมด' },
                { key: 'deposit&pend-deposit', title: 'เติมเงิน' },
                { key: 'withdraw&pend-withdraw&pend-withdraw-cancelled', title: 'ตัดเงิน' }
            ],
            table_filter_wallet_2_v2: [
                { key: null, title: 'ดูสถานะรายการทั้งหมด' },
                { key: 'unsettled', title: 'รอดำเนินการ' },
                { key: 'settled', title: 'สำเร็จ' }
            ],
        }
    },
    filters: {
        dateFormat(date, use_walletV2) {
            if (use_walletV2) {
                // UTC to +07:00
                return moment(date, "YYYY-MM-DD HH:mm:ss")
                    .add(7, 'hours')
                    .format("DD/MM/YYYY HH:mm:ss");
            }

            return moment(date, "YYYY-MM-DD HH:mm:ss")
                .format("DD/MM/YYYY HH:mm:ss");
        },
    },
    mounted() {
        this.assignFuncsByThemeName();

        this.funcHistoryTopUpWallet();
    },
    methods: {
        logEvent(event, date) {
            const { minDate, maxDate } = dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        changePage(i) {
            if (this.pagination.currentPage == i) {
                return
            }
            this.pagination.currentPage = i

            this.funcHistoryTopUpWallet()
        },

        historyUsageWallet() {
            this.busy = true;
            let dateStart = moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")
            let dateEnd = moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")
            this.$http
                .get(
                    this.$API_URL + "/wallet/agent/transaction/info", {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                    params: {
                        date_start: dateStart,
                        date_end: dateEnd,
                        subject: this.filterStatus,
                        page: this.pagination.currentPage
                    }
                }
                )
                .then(res => {
                    let data = res.data.data;
                    this.dataUsegeWallet = data.data
                    this.pagination.totalPage = data.total_page
                    this.pagination.totalItem = data.total_item
                    this.pagination.perPage = data.per_page
                    this.pagination.currentPage = data.page
                    this.busy = false;
                })
                .catch(() => { });
        },
        historyTopUpWalletV2() {
            this.busy = true;

            const param_start_date = moment(this.filters.startDate)
                .startOf('day')
                .subtract(7, 'hours')
                .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
            const param_end_date = moment(this.filters.endDate)
                .endOf('day')
                .subtract(7, 'hours')
                .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")

            let filter_status = this.filterStatus
                ? this.filterStatus.replaceAll('&', ',')
                : [
                    this.wallet_subject_deposit,
                    this.wallet_subject_withdraw,
                    this.wallet_subject_pendwithdrawconfirmed,
                    this.wallet_subject_pendwithdraw,
                    this.wallet_subject_pendwithdrawcancelled,
                ].join(',');
            if (this.filterStatus2 === 'settled') {
                filter_status = removePendParams(filter_status)
            } else if (this.filterStatus2 === 'unsettled') {
                filter_status = keepOnlyPendParams(filter_status)
            }

            this.$http
                .get(this.$API_URL + "/wallet_v2/agent/transaction/paginate/with-actor", {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                    params: {
                        page: this.pagination.currentPage,
                        limit: this.pagination.perPage,
                        sort_option: 'updated_at:desc',
                        subject: filter_status,
                        start_date: param_start_date,
                        end_date: param_end_date
                    }
                }
                )
                .then(res => {
                    const res_data = res.data.data;
                    const res_data_items = [...res_data.items];

                    this.dataUsegeWallet = res_data_items;
                    this.pagination.currentPage = res_data.page;
                    this.pagination.perPage = res_data.limit
                    this.pagination.totalPage = res_data.total_pages
                    this.pagination.totalItem = res_data.total_rows
                })
                .catch(() => {
                    this.dataUsegeWallet = [];
                })
                .finally(() => {
                    this.busy = false;
                });
        },

        async getDataBranceExportExcel() {
            return new Promise(resolve => {
                let ExcelTask = []
                let page = 1;
                for (let i = 0; i < this.pagination.totalPage; i++) {
                    ExcelTask.push(this.$http
                        .get(
                            this.$API_URL + "/wallet/agent/transaction/info", {
                            headers: {
                                Token: localStorage.getItem("access_token")
                            },
                            params: {
                                date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                subject: this.filterStatus,
                                page: page++
                            }
                        }
                        )
                    )
                }

                Promise.all(ExcelTask).then((resData) => {
                    let dataExcel = [];
                    resData.forEach(data => {
                        let results = convertDataWallet(data.data.data.data)
                        dataExcel.push(...results)
                    })
                    resolve(dataExcel)
                })
            })
        },
        async getDataBranceExportExcelWalletV2() {
            return new Promise(resolve => {
                const ExcelTask = [];

                let iter_page = 1;
                const start_date = moment(this.filters.startDate)
                    .startOf('day')
                    .subtract(7, 'hours')
                    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
                const end_date = moment(this.filters.endDate)
                    .endOf('day')
                    .subtract(7, 'hours')
                    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

                let filter_status = this.filterStatus
                    ? this.filterStatus.replaceAll('&', ',')
                    : [
                        this.wallet_subject_deposit,
                        this.wallet_subject_withdraw,
                        this.wallet_subject_pendwithdrawconfirmed,
                        this.wallet_subject_pendwithdraw,
                        this.wallet_subject_pendwithdrawcancelled,
                    ].join(',');
                if (this.filterStatus2 === 'settled') {
                    filter_status = removePendParams(filter_status)
                } else if (this.filterStatus2 === 'unsettled') {
                    filter_status = keepOnlyPendParams(filter_status)
                }

                for (let i = 0; i < this.pagination.totalPage; i++) {
                    const promise = this.$http
                        .get(
                            this.$API_URL + "/wallet_v2/agent/transaction/paginate", {
                            headers: {
                                Token: localStorage.getItem("access_token")
                            },
                            params: {
                                page: iter_page,
                                limit: this.pagination.perPage,
                                subject: filter_status,
                                start_date: start_date,
                                end_date: end_date
                            }
                        });

                    ExcelTask.push({ promise, index: i });
                    iter_page++;
                }

                Promise.all(ExcelTask.map(p => p.promise)).then((res) => {
                    const sorted_res = ExcelTask.sort((a, b) => a.index - b.index)
                        .map(p => res[p.index]);

                    const data_excel = [];
                    for (const each_res of sorted_res) {
                        if (
                            each_res &&
                            each_res.data &&
                            each_res.data.data &&
                            each_res.data.data.items
                        ) {
                            const items = [...each_res.data.data.items];
                            for (const item of items) {
                                // Map to match tablePrint
                                const created_at = moment(item['created_at'], "YYYY-MM-DD HH:mm:ss")
                                    .add(7, 'hours')
                                    .format("DD/MM/YYYY HH:mm:ss");

                                const updated_at = (
                                    [
                                        this.wallet_subject_deposit,
                                        this.wallet_subject_withdraw,
                                        this.wallet_subject_pendwithdrawconfirmed,
                                        this.wallet_subject_pendwithdrawcancelled
                                    ].includes(item['subject']) && item['updated_at']
                                )
                                    ? moment(item['updated_at'], "YYYY-MM-DD HH:mm:ss")
                                        .add(7, 'hours')
                                        .format("DD/MM/YYYY HH:mm:ss")
                                    : '-';

                                const tx_type = this.transformTxTypeText(item['subject'], item['ref_code'], item['remark']);
                                // Excel export: include leading +/- signs for main value
                                let sign = '';
                                if (this.wallet_subject_deposit === item['subject']) {
                                    sign = '+';
                                } else if (
                                    this.wallet_subject_withdraw === item['subject'] ||
                                    this.wallet_subject_pendwithdraw === item['subject'] ||
                                    this.wallet_subject_pendwithdrawconfirmed === item['subject']
                                ) {
                                    sign = '-';
                                } else if (this.wallet_subject_pendwithdrawcancelled === item['subject']) {
                                    sign = (item['ref_code'] === 'REFUND') ? '+' : '-';
                                }
                                const value_main = `${sign}${numFormat(item['value'], '0,0.00')}`;
                                const coupon_part = (item['coupon'] && item['coupon']['total_value'])
                                    ? ` / ${numFormat(-item['coupon']['total_value'], '0,0.00')}`
                                    : '';
                                const value = `${value_main}${coupon_part}`;

                                const status = [
                                    this.wallet_subject_deposit,
                                    this.wallet_subject_withdraw,
                                    this.wallet_subject_pendwithdrawconfirmed,
                                    this.wallet_subject_pendwithdrawcancelled
                                ].includes(item['subject']) ? 'สำเร็จ' : 'รอดำเนินการ';

                                let available_balance = '-';
                                if ([
                                    this.wallet_subject_deposit,
                                    this.wallet_subject_withdraw,
                                    this.wallet_subject_pendwithdrawconfirmed,
                                    this.wallet_subject_pendwithdrawcancelled,
                                    this.wallet_subject_pendwithdraw
                                ].includes(item['subject'])) {
                                    available_balance = numFormat(item['available_balance'], '0,0.00');
                                }

                                const row = {
                                    created_at,
                                    id: item['id'],
                                    ref_no2: item['subject'] && String(item['subject']).includes('deposit') ? '' : (item['ref_no2'] || ''),
                                    tx_type,
                                    value,
                                    status,
                                    updated_at,
                                    available_balance,
                                    remark: this.parseTextFieldRemark(item['remark'])
                                };

                                data_excel.push(row);
                            }
                        }
                    }

                    resolve(data_excel);
                })
            })
        },

        fields(type = null) {
            let fields = []
            if (type === 'excel' && this.main_use_walletV2) {
                return [
                    { key: "created_at", field: "created_at", label: "วันเวลาที่ทำรายการ", sortable: true, class: "text-center" },
                    { key: "id", field: "id", label: "เลขที่รายการ", sortable: true, class: "text-center" },
                    { key: "ref_no2", field: "ref_no2", label: "เลขแทรคกิ้ง", sortable: true, class: "text-center" },
                    { key: "tx_type", field: "tx_type", label: "ประเภทรายการ", sortable: true, class: "text-center" },
                    { key: "value", field: "value", label: "ธุรกรรม/ส่วนลด", sortable: true, class: "text-center" },
                    { key: "status", field: "status", label: "สถานะ", sortable: true, class: "text-center" },
                    // { key: "updated_at", field: "updated_at", label: "วันเวลาที่รายการสำเร็จ", sortable: true, class: "text-center" },
                    { key: "available_balance", field: "available_balance", label: "ยอดเงินคงเหลือ", sortable: true, class: "text-center" },
                    { key: "remark", field: "remark", label: "หมายเหตุ", sortable: true, class: "text-center" }
                ];
            }

            if (this.main_use_walletV2 && this.main_allow_coupon) {
                fields = [
                    { key: "index", field: "index", label: "ลำดับ", sortable: true },
                    { key: "created_at", field: "created_at", label: "วันเวลาที่ทำรายการ", sortable: true, class: "text-center" },
                    { key: "transaction_id", field: "transaction_id", label: "เลขที่รายการ", sortable: true, class: "text-center" },
                    { key: "ref_no2", field: "ref_no2", label: "เลขแทรคกิ้ง", sortable: true, class: "text-center" },
                    { key: "subject", field: "subject", label: "ประเภทรายการ", class: "text-center", sortable: true },
                    { key: "credit", field: "credit", label: "ธุรกรรม", sortable: true, class: "text-center" },
                    { key: "coupon", field: "coupon", label: "คูปองส่วนลด (บาท)", sortable: true, class: "text-center" },
                    { key: "status", field: "status", label: "สถานะ", sortable: true, class: "text-center" },
                    // { key: "credit_withdraw", field: "credit_withdraw", label: "เครดิตออก", sortable: true , class:"text-center" },
                    { key: "available_credit", field: "available_credit", label: "เครดิตที่ใช้ได้", sortable: true, class: "text-center" },
                    { key: "accumulated_credit", field: "accumulated_credit", label: "เครดิตคงเหลือ", sortable: true, class: "text-center" },
                    { key: "remark", field: "remark", label: "หมายเหตุ", sortable: true, class: "text-center" }
                ];
            } else {
                fields = [
                    { key: "index", field: "index", label: "ลำดับ", sortable: true },
                    { key: "created_at", field: "created_at", label: "วันเวลาที่ทำรายการ", sortable: true, class: "text-center" },
                    { key: "transaction_id", field: "transaction_id", label: "เลขที่รายการ", sortable: true, class: "text-center" },
                    { key: "subject", field: "subject", label: "ประเภทรายการ", class: "text-center", sortable: true },
                    { key: "credit", field: "credit", label: "Transaction", sortable: true, class: "text-center" },
                    { key: "status", field: "status", label: "สถานะ", sortable: true, class: "text-center" },
                    // { key: "credit_withdraw", field: "credit_withdraw", label: "เครดิตออก", sortable: true , class:"text-center" },
                    { key: "available_credit", field: "available_credit", label: "เครดิตที่ใช้ได้", sortable: true, class: "text-center" },
                    { key: "accumulated_credit", field: "accumulated_credit", label: "เครดิตคงเหลือ", sortable: true, class: "text-center" },
                    { key: "ref_no2", field: "ref_no2", label: "หมายเหตุ", sortable: true, class: "text-center" }
                ];
            }


            // เอาลำดับออกนะครับ :)
            if (type === 'excel') {
                fields.splice(0, 1)
            }

            return fields
        },

        assignFuncsByThemeName() {
            if (this.main_use_walletV2) {
                this.funcHistoryTopUpWallet = this.historyTopUpWalletV2;
                this.funcGetDataBranceExportExcel = this.getDataBranceExportExcelWalletV2;
            } else {
                this.funcHistoryTopUpWallet = this.historyUsageWallet;
                this.funcGetDataBranceExportExcel = this.getDataBranceExportExcel;
            }
        },

        parseTextFieldRemark(remark) {
            switch (remark) {
                case "OVERWEIGHT_CHARGE":
                    return "ส่วนต่างค่าขนส่ง"
                case "INSURANCE_CHARGE":
                    return "ค่าประกัน"
                default:
                    return remark
            }
        }
    }
};
</script>
